var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v4-common-list-container"},[_c('div',{staticClass:"container__header scrollObj"},[_c('router-link',{attrs:{"tag":"div","to":{
        path: _vm.newsPath
      },"active-class":"active"}},[_c('p',[_vm._v("news")]),_c('div',{staticClass:"line"})]),_c('router-link',{attrs:{"tag":"div","to":{
        path: '/list/publication'
      },"active-class":"active"}},[_c('p',[_vm._v("publication")]),_c('div',{staticClass:"line"})])],1),_c('router-view',{staticClass:"container__inner"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }